import React, { Component } from "react";
import { connect } from "react-redux";
import { getAllGroups } from "redux/actions/InboxActions";
import { CircularProgress } from "@material-ui/core";
import clsx from "clsx";
import { groupOrgStatus } from "redux/Types";
import { escapeHtmlEntities } from "./CommonFunc";

class GroupDisplay extends Component {
  componentDidMount() { }

  getGroupName = (group) => {
    return JSON.parse(escapeHtmlEntities(JSON.stringify((group.name || group.label))));
  }

  getGroupNameList = (groupIds, groups) => {
    const { classes } = this.props;
    if (groupIds.length > 0 && groups.length > 0) {
      let groupNames = groupIds.map((e) => {
        e = e?.toString() || "";
        let gUser = { name: "", status: "" }
        // return groups.find(i => i.externalRefId == e?.split("_")[0])?.name || groups.find(i => i.externalRefId == e?.split("_")[0])?.label || groups.find(i => i.groupId == e)?.label || groups.find(i => i.groupId == e)?.name || ""
        gUser.name = groups.find(i => i.externalRefId == e?.split("_")[0])?.name || groups.find(i => i.externalRefId == e?.split("_")[0])?.label || groups.find(i => i.groupId == e)?.label || groups.find(i => i.groupId == e)?.name || ""
        gUser.status = groups.find(i => i.externalRefId == e?.split("_")[0])?.status || groups.find(i => i.externalRefId == e)?.status || groups.find(i => i.groupId == e)?.status || ""
        return JSON.parse(escapeHtmlEntities(JSON.stringify(gUser)));
      })
      // return groupNames.join(", ")
      return (
        groupNames.map((g, i) => {
          return <span className={clsx( g.status == groupOrgStatus.ARCHIVED ? classes?.archivedGroupTextCol : null)} title={`${g.name} ${g.status == groupOrgStatus.ARCHIVED ?" [Archived]":""}`} > {`${JSON.parse(escapeHtmlEntities(JSON.stringify(g.name)))} ${g.status == groupOrgStatus.ARCHIVED ?" [Archived]":""}`}{ (i !== groupNames.length -1) && ","} </span>
        }
        ))
    }
    else {
      return ""
    }
  }

  render() {
    const { groupId, groups, loadingGroups } = this.props;
    if (loadingGroups) return <CircularProgress />;

    if (Array.isArray(groupId)) {
      return (
        this.getGroupNameList(groupId, groups)
        // <span title={this.getGroupNameList(groupId,groups)}>{this.getGroupNameList(groupId,groups)} </span>
      );
    }
    else {
      return (
        <span title={this.getGroupName(groups.find((v) => +v.groupId === +groupId) || { name: " " })}>{this.getGroupName(groups.find((v) => +v.groupId === +groupId) || { name: " " })} </span>
      );
    }
  }

}

const mapStateToProps = (state) => ({
  groups: state.inbox.allGroups,
  loadingGroups: state.inbox.loadingGroups,
});

export default connect(mapStateToProps, { getAllGroups })(GroupDisplay);
